import { render, staticRenderFns } from "./DevelopersAPI.vue?vue&type=template&id=ccd01e7c"
import script from "./DevelopersAPI.vue?vue&type=script&lang=js"
export * from "./DevelopersAPI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports